import { ClientReportFilter } from '../_models/reports/client-report-filter.model';
import { NATIVE_CLIENT_REPORT_CODES } from '../_constants/client-report-codes';
import { ALL_SESSION_REPORT_STATUS_IDS } from '../_constants/session-report-statuses';

/** yyyy-MM-dd of the picked calendar day (timezone offset removed). */
export function toDateOnly(date: any): string {
    const d = new Date(date);
    d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
    return d.toISOString().substring(0, 10);
}

/** Native report code for the selected ReportType, or null for a report type with no native version. */
export function getNativeReportCode(report: { shortCode?: string }): string {
    if (report == null || report.shortCode == null) { return null; }
    const code = NATIVE_CLIENT_REPORT_CODES[report.shortCode];
    return code != null ? code : null;
}

/**
 * Builds the shared api/ClientReport filter from a reports-page form value.
 * studentIds is passed separately because the two pages resolve it differently.
 */
export function buildClientReportFilter(formValue: any, studentIds: number[]): ClientReportFilter {
    const filter = new ClientReportFilter();
    filter.startDate = toDateOnly(formValue.startDate);
    filter.endDate = toDateOnly(formValue.endDate);
    filter.companyIds = formValue.brands != null && formValue.brands.length > 0 ? formValue.brands : [];
    filter.clientIds = formValue.clients != null ? [formValue.clients] : null;
    filter.studentIds = studentIds != null && studentIds.length > 0 ? studentIds : null;
    filter.coordinatorIds = formValue.coordinators != null ? [formValue.coordinators] : null;
    filter.tutorIds = formValue.tutors != null ? [formValue.tutors] : null;
    filter.placementIds = null;
    filter.statusIds = toStatusIds(formValue.statuses);
    return filter;
}

/**
 * Null when nothing or everything is selected — both mean "no status filter", which is also what the
 * server does with null, so an unchanged default never narrows the report.
 */
export function toStatusIds(selected: number[] | null | undefined): number[] | null {
    if (selected == null || selected.length === 0) { return null; }
    const everySelected = ALL_SESSION_REPORT_STATUS_IDS.every(id => selected.includes(id));
    return everySelected ? null : selected;
}
